export default __webpack_public_path__ + "static/media/womenCeremonyDress.47986b0e.svg";